import "./column-components.c66242f5.js";
import "./column-components.5cffef96.js";
import "./column-components.488d51c9.js";
import "./column-components.b2a20dc1.js";
import "./column-components.a60d0bb9.js";
import "./column-components.c077d708.js";
import "./column-components.235c8c8c.js";
import "./column-components.8ba844d8.js";
import {useContext as $8qd2c$useContext} from "react";


function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea149"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea149"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
var $c847b9cc9be90f1e$exports = {};

$parcel$export($c847b9cc9be90f1e$exports, "NoteComponent", () => $c847b9cc9be90f1e$export$1e92413934596f41);
$parcel$export($c847b9cc9be90f1e$exports, "StaticNotesColumn", () => $c847b9cc9be90f1e$export$c6e73cac972b98c9);
$parcel$export($c847b9cc9be90f1e$exports, "NotesColumn", () => $c847b9cc9be90f1e$export$78231d3424a637d3);
$parcel$export($c847b9cc9be90f1e$exports, "NoteTextEditor", () => (parcelRequire("jMtLz")).NoteTextEditor);
$parcel$export($c847b9cc9be90f1e$exports, "NoteEditor", () => (parcelRequire("jMtLz")).NoteEditor);
$parcel$export($c847b9cc9be90f1e$exports, "NoteEditorContext", () => (parcelRequire("jMtLz")).NoteEditorContext);


var $4bJ9d = parcelRequire("4bJ9d");

var $8C0rw = parcelRequire("8C0rw");

var $21tVR = parcelRequire("21tVR");

var $aVUB5 = parcelRequire("aVUB5");

var $dl5CL = parcelRequire("dl5CL");

var $jMtLz = parcelRequire("jMtLz");

var $66xE8 = parcelRequire("66xE8");

var $dLxl2 = parcelRequire("dLxl2");
function $c847b9cc9be90f1e$export$1e92413934596f41(props) {
    const { visibility: visibility, note: note, onClick: onClick } = props;
    const text = note.note;
    return (0, $4bJ9d.default)("p.col-note-label", {
        style: {
            visibility: visibility
        },
        onClick: onClick
    }, text);
}
const $c847b9cc9be90f1e$var$CancelEditUnderlay = function() {
    const { setEditingNote: setEditingNote } = (0, $8qd2c$useContext)((0, $jMtLz.NoteEditorContext));
    return (0, $4bJ9d.default)((0, $dl5CL.NoteUnderlay), {
        onClick (evt) {
            setEditingNote(null);
            evt.stopPropagation();
        }
    });
};
function $c847b9cc9be90f1e$var$EditableNotesColumn(props) {
    const { width: width, paddingLeft: paddingLeft = 60, transform: transform, notes: notes, inEditMode: inEditMode = false, onUpdateNote: onUpdateNote, onDeleteNote: onDeleteNote, onCreateNote: onCreateNote, noteComponent: noteComponent = $c847b9cc9be90f1e$export$1e92413934596f41, noteEditor: noteEditor = (0, $jMtLz.NoteTextEditor), allowPositionEditing: allowPositionEditing = false, forceOptions: forceOptions, onClickNote: onClickNote } = props;
    const innerWidth = width - paddingLeft;
    return (0, $4bJ9d.default)((0, $dl5CL.NoteLayoutProvider), {
        notes: notes,
        width: innerWidth,
        paddingLeft: paddingLeft,
        noteComponent: noteComponent,
        forceOptions: forceOptions
    }, [
        (0, $4bJ9d.default)((0, $jMtLz.NoteEditorProvider), {
            inEditMode: inEditMode,
            noteEditor: noteEditor,
            onCreateNote: onCreateNote,
            onUpdateNote: onUpdateNote,
            onDeleteNote: onDeleteNote
        }, [
            (0, $4bJ9d.default)("g.section-log", {
                transform: transform,
                className: "focusable editable"
            }, [
                (0, $4bJ9d.default)((0, $21tVR.default)),
                (0, $4bJ9d.default)($c847b9cc9be90f1e$var$CancelEditUnderlay),
                (0, $4bJ9d.default)((0, $8C0rw.NotesList), {
                    onClickNote: onClickNote
                }),
                (0, $4bJ9d.default)((0, $66xE8.NewNotePositioner)),
                (0, $4bJ9d.default)((0, $jMtLz.NoteEditor), {
                    allowPositionEditing: allowPositionEditing
                })
            ])
        ])
    ]);
}
function $c847b9cc9be90f1e$var$FocusableNoteColumn(props) {
    /** A notes column with selection capabilities. */ const { width: width, paddingLeft: paddingLeft = 60, transform: transform, notes: notes, forceOptions: forceOptions, noteComponent: noteComponent = $c847b9cc9be90f1e$export$1e92413934596f41, focusedNoteComponent: focusedNoteComponent = $c847b9cc9be90f1e$export$1e92413934596f41, deltaConnectorAttachment: deltaConnectorAttachment, onClickNote: onClickNote } = props;
    const innerWidth = width - paddingLeft;
    return (0, $4bJ9d.default)((0, $dl5CL.NoteLayoutProvider), {
        notes: notes,
        width: innerWidth,
        paddingLeft: paddingLeft,
        noteComponent: noteComponent,
        forceOptions: forceOptions
    }, [
        (0, $4bJ9d.default)((0, $jMtLz.NoteEditorProvider), {
            inEditMode: true,
            noteEditor: focusedNoteComponent
        }, [
            (0, $4bJ9d.default)("g.section-log", {
                transform: transform,
                className: "focusable"
            }, [
                (0, $4bJ9d.default)((0, $21tVR.default)),
                (0, $4bJ9d.default)($c847b9cc9be90f1e$var$CancelEditUnderlay),
                (0, $4bJ9d.default)((0, $8C0rw.NotesList), {
                    onClickNote: onClickNote,
                    deltaConnectorAttachment: deltaConnectorAttachment
                }),
                (0, $4bJ9d.default)((0, $jMtLz.NoteEditor), {
                    allowPositionEditing: false
                })
            ])
        ])
    ]);
}
function $c847b9cc9be90f1e$export$c6e73cac972b98c9(props) {
    /** A non-editable notes column. */ const { width: width, paddingLeft: paddingLeft = 60, transform: transform, notes: notes, noteComponent: noteComponent = $c847b9cc9be90f1e$export$1e92413934596f41, deltaConnectorAttachment: deltaConnectorAttachment, onClickNote: onClickNote, forceOptions: forceOptions, children: children } = props;
    const innerWidth = width - paddingLeft;
    return (0, $4bJ9d.default)((0, $dl5CL.NoteLayoutProvider), {
        notes: notes,
        width: innerWidth,
        paddingLeft: paddingLeft,
        noteComponent: noteComponent,
        forceOptions: forceOptions
    }, [
        (0, $4bJ9d.default)("g.section-log", {
            transform: transform
        }, [
            (0, $4bJ9d.default)((0, $21tVR.default)),
            (0, $4bJ9d.default)((0, $8C0rw.NotesList), {
                deltaConnectorAttachment: deltaConnectorAttachment,
                onClickNote: onClickNote
            }),
            children
        ])
    ]);
}
function $c847b9cc9be90f1e$export$78231d3424a637d3(props) {
    const { editable: editable = false, ...rest } = props;
    const ctx = (0, $8qd2c$useContext)((0, $aVUB5.ColumnContext));
    // not sure why we have this here.
    if (ctx?.scaleClamped == null) return null;
    let c = $c847b9cc9be90f1e$export$c6e73cac972b98c9;
    if (editable) c = $c847b9cc9be90f1e$var$EditableNotesColumn;
    else if (rest.focusedNoteComponent != null) c = $c847b9cc9be90f1e$var$FocusableNoteColumn;
    return (0, $4bJ9d.default)(c, rest);
}
$parcel$exportWildcard($c847b9cc9be90f1e$exports, $dLxl2);


export {$c847b9cc9be90f1e$export$1e92413934596f41 as NoteComponent, $c847b9cc9be90f1e$export$c6e73cac972b98c9 as StaticNotesColumn, $c847b9cc9be90f1e$export$78231d3424a637d3 as NotesColumn, $d931bc84f13910ef$export$f3c30e51e696113d as NoteTextEditor, $d931bc84f13910ef$export$9939e67821493b95 as NoteEditor, $d931bc84f13910ef$export$cbc16735c48a2e0f as NoteEditorContext};
//# sourceMappingURL=column-components.7db968c2.js.map
